/* eslint-disable @typescript-eslint/camelcase */
/* eslint-disable camelcase */
import React, { useContext, useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import GlobalContext from '../../contexts/GlobalContext';
import SvgIos from '../SVG/IosIcon';
import SvgAndroid from '../SVG/AndroidIcon';
import { FooterMenuProps, LinkAttributes } from '../../types/footer';
import parse from 'html-react-parser';

const FooterMenu = (props: FooterMenuProps): JSX.Element => {
  const { globalContext } = useContext(GlobalContext);
  const footerServiceName = parse(globalContext.liquid.settings.footer_service_name);
  const isGiveAGiftEnabled = globalContext.liquid.settings.give_a_gift_enabled;
  const isRedeemGiftEnabled = globalContext.liquid.settings.redeem_gift_enabled;
  const isReferAFriendEnabled = globalContext.liquid.settings.enable_refer_a_friend;
  const isIosSmartBannerEnabled = globalContext.liquid.settings.enable_smartbanner_ios;
  const isAndroidSmartBannerEnabled = globalContext.liquid.settings.enable_smartbanner_android;
  const footerConfigData = window.caastle.linklists;
  const [footerConfig, setFooterConfig] = useState(footerConfigData);
  const linkDefaults = {
    faq: {
      id: 'support_center',
      className: 'footer-block__list-link'
    },
    refer_a_friend: {
      id: 'refer_a_friend',
      className: 'footer-block__list-link'
    },
    give_a_gift: {
      id: 'give-a-gift-link-footer',
      className: 'footer-block__list-link'
    },
    redeem_gift: {
      id: 'redeem-gift-link-footer',
      className: 'footer-block__list-link'
    },
    appios: {
      id: '',
      className: 'footer-block__list-link i-block app-link-ios'
    },
    appandroid: {
      id: '',
      className: 'footer-block__list-link i-block'
    },
    'do-not-sell-and-share-my-personal-information': {
      id: 'dnss',
      className: 'footer-block__list-link ot-sdk-show-settings'
    },
    'affiliate-policy': {
      id: '',
      className: 'footer-block__list-link'
    }
  };
  const updateFooterConfig = (): void => {
    const faqUrl = globalContext.liquid.settings.faq_url;

    setFooterConfig((prevConfig) => ({
      ...prevConfig,
      'footer-1': {
        ...prevConfig['footer-1'],
        title: prevConfig['footer-1'].title ? prevConfig['footer-1'].title : footerServiceName,
        links: prevConfig['footer-1'].links.map((link) => (link.handle === 'faq' && faqUrl ? { ...link, url: faqUrl } : link))
      }
    }));
  };
  const getLinkAttributes = (link): LinkAttributes => {
    const defaults = linkDefaults[link.handle] || {};

    return {
      to: link.url.startsWith('/') ? link.url : { pathname: link.url },
      target: link.url.startsWith('/') ? '' : '_blank',
      id: defaults.id || '',
      className: defaults.className || 'footer-block__list-link',
      onClick: (event): void => globalContext.gtm.pushLinkEvent(event, 'Footer_NavBar', {
        title: link.title
      })
    };
  };
  const getLinkElement = (link): JSX.Element => {
    const linkAttributes = getLinkAttributes(link);
    const linkConditions = [
      {
        condition: !isGiveAGiftEnabled && link.url === '/pages/give-a-gift',
        jsx: null
      },
      {
        condition: !isRedeemGiftEnabled && link.url === '/pages/redeem-gift',
        jsx: null
      },
      {
        condition:
          !isReferAFriendEnabled && link.url === '/pages/refer-a-friend',
        jsx: null
      },
      {
        condition: isIosSmartBannerEnabled && link.handle === 'appios',
        jsx: (
          <Link
            {...linkAttributes}
            onClick={(event): void => globalContext.gtm.pushLinkEvent(event, 'Footer_AppStore')
            }>
            <SvgIos />
          </Link>
        )
      },
      {
        condition: isAndroidSmartBannerEnabled && link.handle === 'appandroid',
        jsx: (
          <Link
            {...linkAttributes}
            onClick={(event): void => globalContext.gtm.pushLinkEvent(event, 'Footer_PlayStore')
            }>
            <SvgAndroid />
          </Link>
        )
      },
      {
        condition: link.handle === 'do-not-sell-and-share-my-personal-information',
        jsx: (
          <a id={linkDefaults[link.handle]?.id || ''} className={linkDefaults[link.handle]?.className || ''}
          >
            Do Not Sell or Share My Personal Information
          </a>
        )
      }
    ];
    const matchedCondition = linkConditions.find((linkCondition) => linkCondition.condition);

    return matchedCondition ? (
      matchedCondition.jsx
    ) : (
      <Link {...linkAttributes}>{link.title}</Link>
    );
  };

  useEffect(() => {
    updateFooterConfig();
  }, [footerServiceName]);

  return (
    <div className="footer-block">
      <h4 className="footer-block__heading js-footer-c1-title">{footerConfig[`footer-${props.section}`].title}</h4>
      <ul className="no-bullet footer-block__list">
        {footerConfig[`footer-${props.section}`].links.map((link, index) => (
          <li className="footer-block__list-item" key={index}>{getLinkElement(link)}</li>
        ))}
      </ul>
    </div>
  );
};

export default FooterMenu;
